import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import {backendApiPath} from "../../../../../api/src/constants/api_path";
import prepare_headers from "../../../store/prepare_headers";

export const contactFormApi = createApi({
    reducerPath: "contactFormApi",
    baseQuery: fetchBaseQuery({
        baseUrl: backendApiPath.contactForm,
        prepareHeaders: prepare_headers,
        credentials: "include"
    }),
    endpoints: () => ({})
});
